import { useCallback } from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { SparkleIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Sparkle';
import { TitleMedium1 } from '@zola/zola-ui/src/typography/Headings';

import { useModal } from '~/contexts/ModalContext';

import styles from './vendorDashboardUpgradeModal.module.less';

interface VendorDashboardUpgradeModalProps {
  /**
   * Optional callback for when the primary button is clicked
   */
  onTourStart?: () => void;

  /**
   * Optional callback for when the secondary button is clicked
   */
  onTourSkip?: () => void;
}

export const useVendorDashboardUpgradeModal = () => {
  const { showCustomModal } = useModal();

  const showVendorDashboardUpgradeModal = useCallback(
    ({ onTourStart, onTourSkip }: VendorDashboardUpgradeModalProps) => {
      showCustomModal(
        VendorDashboardUpgradeModal,
        {
          onTourStart,
          onTourSkip,
        },
        {
          className: styles.vendorDashboardUpgradeModalContainer,
          closeOnEsc: false,
          closeOnOverlayClick: false,
          mobileHalfSheet: true,
        }
      );
    },
    [showCustomModal]
  );

  return { showVendorDashboardUpgradeModal };
};

export const VendorDashboardUpgradeModal = ({
  onTourStart,
  onTourSkip,
}: VendorDashboardUpgradeModalProps) => {
  const { hideModal } = useModal();

  const handleTourStart = () => {
    hideModal();
    onTourStart?.();
  };

  const handleTourSkip = () => {
    hideModal();
    onTourSkip?.();
  };

  return (
    <div className={styles.vendorDashboardUpgradeModal}>
      <SparkleIcon width={48} height={48} />
      <TitleMedium1 className={styles.heading} presentation="h4">
        Your dashboard just got upgraded!
      </TitleMedium1>
      <ButtonV3 className={styles.button} onClick={handleTourStart} size="large">
        See what’s new
      </ButtonV3>
      <LinkV2 className={styles.button} role="button" onClick={handleTourSkip} noTextTransform>
        Not right now
      </LinkV2>
    </div>
  );
};
